let d = [], n, o;
function i() {
  if (o === void 0) {
    const e = window.innerWidth - document.documentElement.clientWidth;
    if (e > 0) {
      const t = parseInt(
        window.getComputedStyle(document.body).getPropertyValue("padding-right"),
        10
      );
      o = document.body.style.paddingRight, document.body.style.paddingRight = `${t + e}px`;
    }
  }
  n === void 0 && (n = document.body.style.overflow, document.body.style.overflow = "hidden");
}
function l() {
  o !== void 0 && (document.body.style.paddingRight = o, o = void 0), n !== void 0 && (document.body.style.overflow = n, n = void 0);
}
function r(e) {
  !e || d.some((t) => t === e) || (d = [...d, e], i());
}
function u(e) {
  !e || !d.some((t) => t === e) || (d = d.filter((t) => t !== e), d.length === 0 && l());
}
export {
  r as disableBodyScroll,
  u as enableBodyScroll
};
//# sourceMappingURL=body-scroll-lock.js.map
